import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportOutputStatusPageComponent } from './report-output-status-page.component';

/** ルーティング */
const routes: Routes = [
  {
    path: '',
    component: ReportOutputStatusPageComponent,
  },
];

/**
 * エントリーページルーティングモジュール
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportOutputStatusRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/page/report-output-status-page/report-output-status-page-routing.module.ts